import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import styles from './LeftPanel.module.css';
import PropTypes from 'prop-types';
import {useIsMobile, DOCS_URL} from '../utils'

import dashboardImg from '../static_files/dashboard.svg';
import dashboardWhiteImg from '../static_files/dashboardwhite.svg';
import myAssetsImg from '../static_files/myassets.svg';
import myAssetsWhiteImg from '../static_files/myassetswhite.svg';
import transactionsImg from '../static_files/transaction.svg';
import transactionsWhiteImg from '../static_files/transactionswhite.svg';
import analyticsImg from '../static_files/analytics.svg';
import analyticsWhiteImg from '../static_files/analyticswhite.svg';
import docsImg from '../static_files/docs.svg';
import twitterIcon from '../static_files/x-twitter.svg';
import discordIcon from '../static_files/Discord.svg';
import accountImg from '../static_files/Account_leftPanel.svg'
import accountBlackImg from '../static_files/Account_leftPanel_black.svg'
import expandImg from "../static_files/left panel expand.svg";
import shrinkAccountImg from '../static_files/Account icon.svg'
import TooltipRight from "../Tooltip/TooltipRight";
import goldShrinkAccountImg from '../static_files/badge gold.svg';
import sapphireShrinkAccountImg from '../static_files/badge sapphire.svg';
import silverShrinkAccountImg from '../static_files/badgesliver.svg';

const LeftPanel = ({
                       walletAddress,
                       isTransactionPage = false,    //对transaction history page 做特殊style处理
                       isAutoShrink = false,           //判断是不是缩小版本
                       onPanelStateChange = (state) => {
                       },  // 新增的回调 prop 传出去
                   }) => {
    const isLargeScreen = useIsMobile(1265);

    const location = useLocation();
    const [currentPath, setCurrentPath] = useState('');
    const navigate = useNavigate();
    const [shrinkLeftPanel, setShrinkLeftPanel] = useState(() => {
        const savedState = localStorage.getItem('shrinkLeftPanel');
        return savedState !== null ? JSON.parse(savedState) : false;
    });
    const [userClass, setUserClass] = useState(
        localStorage.getItem('userClass') || 'General Member'
    );
    useEffect(() => {
        setCurrentPath(location.pathname);
    }, [location.pathname]);
    const handleToggleShrink = () => {
        setShrinkLeftPanel(prevState => {
            const newState = !prevState;
            // 保存到localStorage
            localStorage.setItem('shrinkLeftPanel', JSON.stringify(newState));
            onPanelStateChange(newState);

            return newState;
        });
    };
    // 如果传入屏幕过小
    useEffect(() => {
        if (isAutoShrink || isLargeScreen) {
            setShrinkLeftPanel(true)
        }
    }, [isAutoShrink, isLargeScreen]);

    useEffect(() => {
        document.documentElement.style.setProperty(
            '--panel-width',
            shrinkLeftPanel ? "61.5px" : "189px"
        );
    }, [shrinkLeftPanel]);

    const handleMyAssetsClick = () => {
        const token = localStorage.getItem('gatewayToken');
        if (token) {
            navigate(`/swap?token=${token}`);
        } else {
            navigate('/');
        }
    };

    function getContainerClass(userClass, styles, currentPath) {
        if (userClass === 'Sapphire VIP') {
            return currentPath === '/account' ? styles.selectedSapphireContainer : styles.sapphireContainer;
        } else if (userClass === 'Silver VIP') {
            return currentPath === '/account' ? styles.selectedSilverContainer : styles.silverContainer;
        } else if (userClass === 'Gold VIP') {
            return currentPath === '/account' ? styles.selectedGoldContainer : styles.goldContainer;
        } else {
            return currentPath === '/account' ? styles.selectedAccountContainer : styles.accountContainer;
        }
    }

    function getIconImage(userClass, currentPath, iconaccountImgImg, accountBlackImg) {
        if (currentPath === '/account' &&
            (userClass === 'Silver VIP' || userClass === 'Gold VIP')) {
            return accountBlackImg; // 使用黑色图标
        } else {
            return accountImg;
        }
    }

    function getShrinkIconImage(userClass) {
        if (userClass === 'Sapphire VIP') {
            return sapphireShrinkAccountImg;
        } else if (userClass === 'Silver VIP') {
            return silverShrinkAccountImg;
        } else if (userClass === 'Gold VIP') {
            return goldShrinkAccountImg;
        } else {
            return shrinkAccountImg;
        }
    }

    const containerClass = getContainerClass(userClass, styles, currentPath)
    const accountIcon = getIconImage(userClass, currentPath, accountImg, accountBlackImg);
    const shrinkAccountIcon = getShrinkIconImage(userClass)
    const isDashboardActive = currentPath === '/dashboard';
    const isMyAssetsActive = currentPath === '/' || currentPath.startsWith('/swap');
    const isTransactionsActive = currentPath === '/transaction';
    const isAnalyticsActive = currentPath === '/analytics';

    useEffect(() => {
        if (walletAddress) {

            // TODO Maybe bug here
            setTimeout(() => {
                setUserClass(localStorage.getItem('userClass') || 'General Member');
                //TODO change it back
                // setUserClass('Sapphire VIP')
            }, 500);
        }
    }, [walletAddress]);
    return (
        <div
            className={
                shrinkLeftPanel
                    ? `${styles.shrinkLeftPanel} ${isTransactionPage ? styles.leftPanel2 : styles.leftPanel}`
                    : (isTransactionPage ? styles.leftPanel2 : styles.leftPanel)
            }
        >
            <div
                style={{backgroundColor: 'var(--bg-panel)', width: '100%'}}
            >
                {shrinkLeftPanel ?
                    <div style={{backgroundColor: 'var(--bg-panel)', display: 'flex', alignItems: 'center', height: '41px'}}>
                        <button className={styles.iconButton} onClick={handleToggleShrink}
                                style={{marginLeft: '14px'}}>
                            <img
                                src={expandImg}
                                alt="expandImg"
                            />
                        </button>
                    </div>
                    : <div style={{backgroundColor: 'var(--bg-panel)', display: 'flex', alignItems: 'center', height: '41px'}}>
                        <button
                            className={styles.logoButton}
                            type="button"
                            onClick={() => window.open('https://cutwaterglobal.com', '_blank')}
                            aria-label="Cutwater"
                        >
                            <svg
                                className={styles.logoIcon}
                                viewBox="0 0 48 48"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                            >
                                <path
                                    className={styles.logoC}
                                    d="M34 10C28 6 18 6 12 12C6 18 6 30 12 36C18 42 28 42 34 38"
                                    stroke="#1a2b5f"
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                />
                                <g className={styles.balanceLine}>
                                    <path
                                        className={styles.logoLine}
                                        d="M14 24L34 24"
                                        stroke="#5BA4E6"
                                        strokeWidth="3"
                                        strokeLinecap="round"
                                    />
                                </g>
                                <circle className={styles.logoDot} cx="24" cy="24" r="4" fill="#5BA4E6" />
                            </svg>
                            <span className={styles.logoText}>Cutwater</span>
                        </button>
                        <button className={styles.iconButton} onClick={handleToggleShrink}>
                            <img
                                src={expandImg}
                                alt="expandImg"
                            />
                        </button>
                    </div>
                }
            </div>

            {/* Menu */}
            <div className={styles.leftMenu} style={{width: shrinkLeftPanel ? '61.5px' : '189px'}}>
                <ul className={styles.leftOptionUl}
                    style={{backgroundColor: 'var(--bg-panel)', width: shrinkLeftPanel ? '61.5px' : '189px'}}>
                    {/* Dashboard */}
                    <li
                        className={
                            isDashboardActive
                                ? `${styles.leftOption} ${styles.activeGrey}`
                                : styles.leftOption
                        }
                        style={{paddingLeft: shrinkLeftPanel ? '22px' : '15px'}}
                        onClick={() => navigate('/dashboard')}
                    >
                        {shrinkLeftPanel ?
                            <TooltipRight
                                text={<>Dashboard</>}
                                backgroundColor={"var(--color-primary-navy)"}
                                borderRadius={"6px"}
                                wrapperClassName={styles.leftPanelTooltipWrapper}
                            >
                                <img
                                    style={{marginRight: '12px'}}
                                    src={isDashboardActive ? dashboardWhiteImg : dashboardImg}
                                    alt="Dashboard icon"
                                />
                            </TooltipRight> :
                            <img
                                style={{marginRight: '12px'}}
                                src={isDashboardActive ? dashboardWhiteImg : dashboardImg}
                                alt="Dashboard icon"
                            />}

                        {!shrinkLeftPanel && "Dashboard"}

                    </li>

                    {/* My Assets */}
                    <li
                        className={
                            isMyAssetsActive
                                ? `${styles.leftOption} ${styles.activeGrey}`
                                : styles.leftOption
                        }
                        style={{paddingLeft: shrinkLeftPanel ? '22px' : '15px'}}
                        onClick={handleMyAssetsClick}
                    >
                        {shrinkLeftPanel ?
                            <TooltipRight
                                text={<>My Assets</>}
                                backgroundColor={"var(--color-primary-navy)"}
                                borderRadius={"6px"}
                                wrapperClassName={styles.leftPanelTooltipWrapper}
                            >
                                <img
                                    style={{marginRight: '12px'}}
                                    src={isMyAssetsActive ? myAssetsWhiteImg : myAssetsImg}
                                    alt="My Assets icon"
                                />
                            </TooltipRight> :
                            <img
                                style={{marginRight: '12px'}}
                                src={isMyAssetsActive ? myAssetsWhiteImg : myAssetsImg}
                                alt="My Assets icon"
                            />}

                        {!shrinkLeftPanel && "My Assets"}

                    </li>

                    {/* Transactions */}
                    <li
                        className={
                            isTransactionsActive
                                ? `${styles.leftOption} ${styles.activeGrey}`
                                : styles.leftOption
                        }
                        style={{paddingLeft: shrinkLeftPanel ? '22px' : '15px'}}
                        onClick={() => navigate('/transaction')}
                    >
                        {shrinkLeftPanel ?
                            <TooltipRight
                                text={<>Transactions</>}
                                backgroundColor={"var(--color-primary-navy)"}
                                borderRadius={"6px"}
                                wrapperClassName={styles.leftPanelTooltipWrapper}
                            >
                                <img
                                    style={{marginRight: '12px', marginLeft: "-1px"}}
                                    src={isTransactionsActive ? transactionsWhiteImg : transactionsImg}
                                    alt="Transactions icon"
                                />
                            </TooltipRight> :
                            <img
                                style={{marginRight: '12px', marginLeft: "-1px"}}
                                src={isTransactionsActive ? transactionsWhiteImg : transactionsImg}
                                alt="Transactions icon"
                            />}
                        {!shrinkLeftPanel && "Transactions"}
                    </li>

                    <li
                        className={
                            isAnalyticsActive
                                ? `${styles.leftOption} ${styles.activeGrey}`
                                : styles.leftOption
                        }
                        style={{paddingLeft: shrinkLeftPanel ? '22px' : '15px'}}
                        onClick={() => navigate('/analytics')}
                    >
                        {shrinkLeftPanel ?
                            <TooltipRight
                                text={<>Analytics</>}
                                backgroundColor={"var(--color-primary-navy)"}
                                borderRadius={"6px"}
                                wrapperClassName={styles.leftPanelTooltipWrapper}
                            >
                                <img
                                    style={{marginRight: '12px', marginLeft: "-1px"}}
                                    src={isAnalyticsActive ? analyticsWhiteImg : analyticsImg}
                                    alt="Analytics icon"
                                />
                            </TooltipRight> : <img
                                style={{marginRight: '12px', marginLeft: "-1px"}}
                                src={isAnalyticsActive ? analyticsWhiteImg : analyticsImg}
                                alt="Analytics icon"
                            />}
                        {!shrinkLeftPanel && "Analytics"}
                    </li>


                    {/* Docs */}
                    <li className={
                        currentPath === '/docs'
                            ? `${styles.leftOption} ${styles.activeGrey}`
                            : styles.leftOption
                    }
                        style={{paddingLeft: shrinkLeftPanel ? '22px' : '15px'}}
                        onClick={() => window.open(DOCS_URL, '_blank', 'noopener,noreferrer')}
                    >
                        {shrinkLeftPanel ?
                            <TooltipRight
                                text={<>Docs</>}
                                backgroundColor={"var(--color-primary-navy)"}
                                borderRadius={"6px"}
                                wrapperClassName={styles.leftPanelTooltipWrapper}
                            >
                                <img
                                    style={{marginRight: '12px', marginLeft: "-1px"}}
                                    src={docsImg}
                                    alt="Docs icon"
                                />
                            </TooltipRight> : <img
                                style={{marginRight: '12px', marginLeft: "-1px"}}
                                src={docsImg}
                                alt="Docs icon"
                            />}
                        {!shrinkLeftPanel && "Docs"}
                    </li>
                </ul>
            </div>

            {!shrinkLeftPanel && (
                <div className={styles.socialSection}>
                    <div className={styles.socialDivider} />
                    <div className={styles.socialLinks}>
                        <div
                            className={styles.socialLink}
                            role="button"
                            tabIndex={0}
                            onClick={() => {}}
                        >
                            <span
                                className={styles.socialIcon}
                                style={{'--icon-url': `url(${twitterIcon})`}}
                                aria-hidden="true"
                            />
                            Twitter
                        </div>
                        <div
                            className={styles.socialLink}
                            role="button"
                            tabIndex={0}
                            onClick={() => {}}
                        >
                            <span
                                className={styles.socialIcon}
                                style={{'--icon-url': `url(${discordIcon})`}}
                                aria-hidden="true"
                            />
                            Discord
                        </div>
                    </div>
                </div>
            )}

            {/* Account */}
        {/*    <div className={styles.leftMenu} style={{width: shrinkLeftPanel ? '61.5px' : '189px'}}>*/}
        {/*        <div className={styles.accountOuterContainer}*/}
        {/*             style={{*/}
        {/*                 paddingLeft: shrinkLeftPanel ? '11px' : '15px',*/}
        {/*                 width: shrinkLeftPanel ? '61.5px' : '189px',*/}
        {/*                 paddingTop: shrinkLeftPanel ? '25px' : '0'*/}
        {/*             }}>*/}
        {/*            {shrinkLeftPanel ?*/}

        {/*                // <TooltipRight  text={<>Account</>} backgroundColor={"var(--bg-card)"} borderRadius={"6px"}>*/}
        {/*                <img*/}
        {/*                    style={{*/}
        {/*                        backgroundColor: 'transparent',*/}
        {/*                        height: "38px",*/}
        {/*                        width: "38px",*/}
        {/*                        cursor: 'pointer'*/}

        {/*                    }}*/}
        {/*                    onClick={() => navigate('/account')}*/}
        {/*                    src={shrinkAccountIcon}*/}
        {/*                    alt="account icon"*/}
        {/*                />*/}
        {/*                // </TooltipRight>*/}
        {/*                : <div*/}
        {/*                    className={*/}
        {/*                        `${styles.accountContainer} ` +*/}
        {/*                        `${containerClass} ` +*/}
        {/*                        `${currentPath === '/account' ? styles.activeGrey : ''}`*/}
        {/*                    }*/}
        {/*                    onClick={() => navigate('/account')}*/}
        {/*                >*/}
        {/*                    <img*/}
        {/*                        style={{*/}
        {/*                            backgroundColor: 'transparent',*/}
        {/*                            marginRight: '12px',*/}
        {/*                            marginLeft: "21px",*/}
        {/*                            height: "14.67px",*/}
        {/*                            width: "14.67px"*/}
        {/*                        }}*/}
        {/*                        src={accountIcon}*/}
        {/*                        alt="account icon"*/}
        {/*                    />*/}
        {/*                    Account*/}
        {/*                </div>}*/}
        {/*        </div>*/}
        {/*    </div>*/}

        </div>
    );
};

LeftPanel.propTypes = {
    walletAddress: PropTypes.string // Optional prop
};

export default LeftPanel;
